var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.loadingProcess,"rounded":"lg","variant":"transparent","opacity":"0.9"}},[_c('router-view'),_c('confirm-dialogue',{ref:"confirmDialogue"}),_c('alert-box',{ref:"alertBox"}),_c('userinfo-model',{ref:"userinfoModel"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }